import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const selectResizeTableStore = (state) => state.resizeTable;

const makeSelectResizeTable = () => createSelector(
  selectResizeTableStore,
  ({ reportTableResize }) => reportTableResize,
);

const makeSelectIDB = () => createSelector(
  selectResizeTableStore,
  ({ idb }) => idb,
);

const makeSelectIDBProps = () => createSelector(
  selectResizeTableStore,
  ({ idbProps }) => idbProps,
);

export {
  makeSelectIDB,
  makeSelectIDBProps,
  makeSelectResizeTable,
};
